import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Keys} from "@/constants/key";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";

export class CampaignRibbon extends Phaser.GameObjects.Container {

    private clickCallback: (() => unknown) | undefined;

    constructor(scene: Scene, x: number, y: number, offerName: string, clickCallback: () => unknown) {
        super(scene);
        this.clickCallback = clickCallback;
        this.setDepth(90);

        this.scene = scene;
        this.x = x;
        this.y = y;

        let campaignButtonRibbon = SpriteUtils.addSprite(this.scene!, 0, 0, Keys.CAMPAIGN_RIBBON);
        let campaignButtonName = TextUtils.addTextAdvanced(this.scene!, offerName.toUpperCase(),
            8, campaignButtonRibbon.y - 6,
            '#ffedd6', 11, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_BOLD);
        campaignButtonName.setShadow(0, 0, '#ffffff');
        campaignButtonName.setStroke('#000000', 2);

        this.add([campaignButtonRibbon, campaignButtonName]);

        campaignButtonRibbon.setInteractive().on('pointerup', clickCallback);
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }

}
